import { styled } from '@mui/material/styles';
import Card from '@mui/material/Card';
import Box from '@mui/material/Box';
import TableRow from '@mui/material/TableRow';

export const StatCard = styled(Card)(({ theme }) => ({
  padding: theme.spacing(3),
}));

export const StatCardContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
}));

export const IconBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'colorVariant',
})<{ colorVariant: 'primary' | 'success' | 'secondary' }>(({ theme, colorVariant }) => {
  const colors = {
    primary: {
      bgcolor: `${theme.palette.primary.main}14`,
      color: theme.palette.primary.main,
    },
    success: {
      bgcolor: `${theme.palette.success.main}14`,
      color: theme.palette.success.main,
    },
    secondary: {
      bgcolor: `${theme.palette.secondary.main}14`,
      color: theme.palette.secondary.main,
    },
  };

  return {
    padding: theme.spacing(1.5),
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    ...colors[colorVariant],
  };
});

export const TableCard = styled(Card)({
  overflow: 'hidden',
});

export const TableHeader = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1.5, 2),
  borderBottom: `1px solid ${theme.palette.divider}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const ClickableRow = styled(TableRow, {
  shouldForwardProp: (prop) => prop !== 'selected',
})<{ selected?: boolean }>(({ theme, selected }) => ({
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
  ...(selected && {
    backgroundColor: `${theme.palette.primary.main}14`,
    '&:hover': {
      backgroundColor: `${theme.palette.primary.main}1F`,
    },
  }),
}));

export const EmptyState = styled(Box)(({ theme }) => ({
  padding: theme.spacing(6),
  textAlign: 'center',
}));
